import { render, staticRenderFns } from "./CategoriasWidget.vue?vue&type=template&id=00315b56&"
import script from "./CategoriasWidget.vue?vue&type=script&lang=js&"
export * from "./CategoriasWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports